import styled from 'styled-components'
import { ArrowRightIcon } from '@shipt/design-system-icons'
import { Column } from '@shipt/design-system-layouts'
import { CarouselButton } from '@/features/shared/elements/Buttons'
import { TextButton } from '@shipt/design-system-buttons'
import { NextLink } from '@/features/shared/elements/Link'

type Props = {
  onClick: () => void
  className?: string
  href: string
}

export const ShelfViewAllButton = ({ onClick, href, className, ...restProps }: Props) => {
  return (
    <Wrapper as={NextLink} href={href} onClick={onClick} className={className} {...restProps}>
      <ViewAllButton variant="tertiary" icon={ArrowRightIcon} forwardedAs="span" />
      <TextButton forwardedAs="span">View all</TextButton>
    </Wrapper>
  )
}

const Wrapper = styled(Column)`
  color: ${({ theme }) => theme.primaryOnLight};
  justify-content: center;
  align-items: center;
  height: 100%;
  width: fit-content;
`

const ViewAllButton = styled(CarouselButton)`
  margin-bottom: 1rem;
`
